<template>
  <div class="months-grid">
    <div
      class="month-cell__container"
      v-for="cell in cells"
      @click="emit('update:modelValue', cell.monthIndex)"
    >
      <slot name="cell" :cell="cell">
        <div
          :class="[
            'month-cell',
            {
              'is-selected': inMonthpicker && modelValue === cell.monthIndex,
              'is-current': inMonthpicker
                ? cell.isCurrent
                : modelValue === cell.monthIndex,
            },
          ]"
        >
          {{ cell.text }}
        </div>
      </slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { generateMonthViewCell } from "../../generators";

const emit = defineEmits<{
  /**Событие выбора месяца */
  (e: "update:modelValue", value: number): void;
}>();

const props = defineProps({
  /**Выбранный индекс месяца (0-11) */
  modelValue: { type: Number },
  /**Отображаемый год */
  viewYear: { type: Number, required: true },
  /**Используется в пикере выбора месяца */
  inMonthpicker: { type: Boolean, required: true },
});

/**Ячейки */
const cells = computed(() => generateMonthViewCell(props.viewYear));
</script>

<style lang="scss" scoped>
.months-grid {
  display: grid;
  width: var(--tir-pm-datepicker__months-grid-w);
  height: var(--tir-pm-datepicker__months-grid-h);
  grid-template-columns: repeat(3, var(--tir-pm-datepicker__month-cell-w));
  justify-content: space-between;
  align-content: space-between;

  .month-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    width: var(--tir-pm-datepicker__month-cell-w);
    height: var(--tir-pm-datepicker__month-cell-h);
    font-size: var(--tir-pm-datepicker__cell-fs);
    font-weight: var(--tir-pm-datepicker__cell-fw);
    line-height: var(--tir-pm-datepicker__cell-lh);
    border-radius: var(--tir-pm-datepicker__cell-br);
    color: var(--tir-pm-datepicker__cell-color);

    &__container {
      cursor: pointer;
    }

    &.is-current {
      color: var(--tir-pm-datepicker__cell-current-color);
    }
    &.is-selected {
      color: var(--tir-pm-datepicker__cell-selected-color);
      background-color: var(--tir-pm-datepicker__cell-selected-bg);

      &:hover {
        background-color: var(--tir-pm-datepicker__cell-hover-selected-bg);
      }
    }
    &:hover {
      background-color: var(--tir-pm-datepicker__cell-hover-bg);
    }
  }
}
</style>
